import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import logger from "./Logger";
import { useQueryExistingTables } from "../services/api/queries/useQueryExistingTables";
import { postAlterShoppingBagTableNumber } from "../services/api/requests/ShoppingBag";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../types/ShoppingBag";

type Props = {
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
}

function useTable({shoppingBagQuery}: Props) {

  const {data: shoppingBag} = shoppingBagQuery

  const [searchParams, setSearchParams] = useSearchParams();
  const place_id = searchParams.get("place_id");
  const table_number = searchParams.get("table");
  const { isLoading: isLoadingExistingTables, data: queryExistingTablesData, error: erroAoCarregarExistingTablesData } =
    useQueryExistingTables(Number(place_id ?? 0) > 0 ? Number(place_id) : 44507);

  let [existingTables, setExistingTables] = useState(new Array<string>());

  useEffect(() => {
    if (queryExistingTablesData?.data?.existing_tables_json_list === undefined) {
      setExistingTables(new Array<string>());
      return;
    }

    setExistingTables(queryExistingTablesData.data.existing_tables_json_list.map(e =>
      e.toString()));
  }, [queryExistingTablesData]);

  /**
   * SE new_table_number não existir no array 'existing_tables', esta função retorna sem fazer nada.
   * @param new_table_number
   */
  const alterTableNumber = async (new_table_number: number) => {

    const procurado = existingTables.filter((v: string) => Number(v) === new_table_number);
    if (procurado.length < 1) return;

    const shoppingBagPrecisaAlterarTableNumber =
      shoppingBag
      && shoppingBag.table_number > 0
      && shoppingBag.table_number !== new_table_number
      && (shoppingBag.custom_origin_qr_code === null || shoppingBag.custom_origin_qr_code === undefined);

    // se shopping bag não tem itens, não precisamos alterar no backend.
    // pois, iremos alterar os queryParam, isso vai causar um get pra o carrinho com o table_number correto.
    // só precisamos alterar o table_number no backend se tiver itens, pois aí estaremos passando
    // os itens deste shoppingBag pra um novo shoppingBag.
    const shoppingBagTemItens = (shoppingBag && shoppingBag.items.length > 0) ?? false;

    logger.log("*************************************************************************");
    logger.log("useTable.ts -> alterTableNumber()");
    logger.log("temShoppingBag", shoppingBag !== undefined);
    logger.log("shoppingBagTemItens", shoppingBagTemItens);
    logger.log("shoppingBagPrecisaAlterarTableNumber", shoppingBagPrecisaAlterarTableNumber);
    logger.log("shoppingBag.custom_origin_qr_code", shoppingBag?.custom_origin_qr_code);
    logger.log("shoppingBag", shoppingBag);
    logger.log("*************************************************************************");

    if (shoppingBagPrecisaAlterarTableNumber && shoppingBagTemItens) {
      shoppingBag.table_number = Number(new_table_number);
      logger.log("vamos atualizar table number no backend...");

      const retorno = await postAlterShoppingBagTableNumber({
        user_order_id: shoppingBag.id,
        shoppingBag: shoppingBag,
      });

      if (!retorno.success) {
        alert("Ocorreu um erro ao tentar atualizar o número da mesa.");
        return;
      }
    }

    const obj = Object.fromEntries(searchParams.entries());
    obj.table = new_table_number.toString();
    setSearchParams(obj);
  };

  return {
    erroAoCarregarExistingTablesData,
    isLoadingExistingTables,
    existingTables,
    table_number,
    alterTableNumber,
  };
}

export default useTable;